import type { ReactNode } from 'react'

/**
 * 剧本资料弹窗底栏
 * - create：取消 + 操作同组右对齐（sm + secondary，与全站新建弹窗一致）
 * - edit：取消居左，保存并编写 / 保存资料居右
 */
export function ScriptDocumentModalFooter({
  layout,
  cancel,
  actions,
}: {
  layout: 'create' | 'edit'
  cancel: ReactNode
  actions: ReactNode
}) {
  if (layout === 'create') {
    return (
      <div className="flex w-full flex-col-reverse gap-2 sm:flex-row sm:items-center sm:justify-end sm:gap-3">
        {cancel}
        {actions}
      </div>
    )
  }

  return (
    <div className="flex w-full flex-col-reverse gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex shrink-0">{cancel}</div>
      <div className="flex flex-col-reverse gap-2 sm:flex-row sm:items-center sm:justify-end sm:gap-3">
        {actions}
      </div>
    </div>
  )
}
